@if (supported) {
<section
  class="array-details"
  aria-label="Site Plan Array Details"
  i18n-aria-label
>
  <h3 i18n>Array Details</h3>
  @switch (state) { @case ('missing') {
  <p role="status" i18n>
    No array analysis is available. Please wait, then refresh.
  </p>
  } @case ('criteria') {
  <p role="status" i18n>
    Array analysis criteria were not met. Check that a supported Site Plan is
    available.
  </p>
  } @case ('error') {
  <p role="alert" i18n>Array analysis could not be completed.</p>
  } @case ('unsupported') {
  <p role="alert" i18n>This array analysis version is not supported.</p>
  } @case ('malformed') {
  <p role="alert" i18n>The array analysis result is incomplete or malformed.</p>
  } @case ('ready') {
  <p class="array-details__summary">
    <strong i18n>Summary:</strong> {{ content.analysis }}
  </p>
  @if (!rows.length) {
  <p role="status" i18n>No application array comparisons are available.</p>
  } @for (row of rows; track row.comparison.comparisonId) {
  <article class="array-details__row">
    <formly-form
      [form]="row.form"
      [fields]="row.fields"
      [model]="row.model"
    ></formly-form>
    @if (row.comparison.analysis) {
    <p class="array-details__analysis">
      <strong i18n>Analysis:</strong> {{ row.comparison.analysis }}
    </p>
    }
  </article>
  } @if (content.unmatchedSitePlanArrays.length) {
  <section
    class="array-details__unmatched"
    aria-label="Unmatched Site Plan Arrays"
    i18n-aria-label
  >
    <h4 class="array-details__unmatched-heading" i18n>
      Unmatched Site Plan Arrays
    </h4>
    <p class="array-details__unmatched-note" i18n>
      These Site Plan arrays have no matching application array.
    </p>
    <div class="array-details__table-container">
      <table
        mat-table
        class="array-details__unmatched-table"
        [dataSource]="content.unmatchedSitePlanArrays"
      >
        <ng-container matColumnDef="array">
          <th mat-header-cell *matHeaderCellDef i18n>Site Plan Array</th>
          <td
            mat-cell
            *matCellDef="let item"
            data-label="Site Plan Array"
            i18n-data-label
          >
            <strong>{{
              item.sitePlanArray.label || item.sitePlanArray.id
            }}</strong>
          </td>
        </ng-container>

        <ng-container matColumnDef="panels">
          <th mat-header-cell *matHeaderCellDef i18n>Panels</th>
          <td
            mat-cell
            *matCellDef="let item"
            data-label="Panels"
            i18n-data-label
          >
            {{ evidenceValue(item.sitePlanArray, 'panelCount') }}
          </td>
        </ng-container>

        <ng-container matColumnDef="tilt">
          <th mat-header-cell *matHeaderCellDef i18n>Tilt</th>
          <td mat-cell *matCellDef="let item" data-label="Tilt" i18n-data-label>
            {{ evidenceValue(item.sitePlanArray, 'tilt') }}
          </td>
        </ng-container>

        <ng-container matColumnDef="azimuth">
          <th mat-header-cell *matHeaderCellDef i18n>Azimuth</th>
          <td
            mat-cell
            *matCellDef="let item"
            data-label="Azimuth"
            i18n-data-label
          >
            {{ evidenceValue(item.sitePlanArray, 'azimuth') }}
          </td>
        </ng-container>

        <ng-container matColumnDef="analysis">
          <th mat-header-cell *matHeaderCellDef i18n>Analysis</th>
          <td
            mat-cell
            *matCellDef="let item"
            data-label="Analysis"
            i18n-data-label
          >
            {{ item.analysis }}
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="unmatchedSitePlanColumns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: unmatchedSitePlanColumns"
        ></tr>
      </table>
    </div>
  </section>
  } } }
</section>
}
